<div class="map-action" (click)="exportToShapeFileAndOpenUrl()">
     <span class="icon-ui-link-external"></span> Export to Shapefile
 </div>
